import { getUserId } from "../utils/getUserId.ts";
import client from "../api_v2/client";
export interface Label { id: number; name: string; color?: string | null }

export async function getLabels(): Promise<Label[]> {
  const uid = getUserId();
  const { data } = await client.get("/ruznama/labels.php", { params: { user_id: uid } });
  return data.result as Label[];
}
export async function createLabel(name: string): Promise<number> {
  const uid = getUserId();
  const { data } = await client.post("/ruznama/create_label.php", { user_id: uid, name });
  const { id } = data;
  return id;
}
export async function deleteLabel(id: number) {
  const uid = getUserId();
  await client.get("/ruznama/delete_label.php", { params: { id, user_id: uid } });
}
export async function renameLabel(id: number, name: string) {
  const uid = getUserId();
  await client.put("/ruznama/rename_label.php", { name, user_id: uid }, { params: { id } });
}
